import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { RefundableRoomsCfarDetails } from "./component";
import { IStoreState } from "../../../../../../reducers/types";
import { getSelectedAccountReferenceIdIfRedemptionEnabled } from "../../../../../rewards/reducer";
import {
  getHotelShopDateRange,
  getHotelShopSelectedLodging,
} from "../../../../../shop/reducer";
import { getSearchedNightCount } from "../../../../../availability/reducer";

const mapStateToProps = (state: IStoreState) => ({
  selectedAccountReferenceId:
    getSelectedAccountReferenceIdIfRedemptionEnabled(state),
  hotelShopDateRange: getHotelShopDateRange(state),
  selectedLodging: getHotelShopSelectedLodging(state),
  nightCount: getSearchedNightCount(state),
});

const connector = connect(mapStateToProps);

export type RefundableRoomsCfarDetailsConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedRefundableRoomsCfarDetails = connector(
  withRouter(RefundableRoomsCfarDetails)
);
